const value = {
    cardTitle: 'Content management in Knowledge',
    cardDescription: 'Import and export content. Update training units easily.',
    importButton: 'Import',
    exportButton: 'Export',
    exportPage: {
      toggle: 'Select all units',
      button: 'Export',
      state: 'Exporting',
      search: 'Search units',
      modalTitle: 'Enter password to export',
      confirm: 'OK',
      decline: 'Cancel',
      inputPlaceholder: 'Password',
      passwordHint: 'Allowed: letters, digits, and special characters.',
      notificationExport: 'Export completed',
      error: {
        VALIDATION_MESSAGE: {
          minLength: 'Length is less than 8 characters',
          maxLength: 'Length is more than 256 characters',
          weakPassword: 'Password must contain uppercase, lowercase, digits and special symbols',
        },
      },
    },
    importPage: {
      dropZoneDescriptionShort: 'Drop files here…',
      dropZoneDescription: 'Drag & drop files here or click to upload',
      clearAll: 'Clear all',
      toggle: 'Update dependencies',
      tooltip: 'Updating dependencies will overwrite your custom settings in “Characteristics” and “Project roles.”',

      fileExist: 'The file «{{name}}» is already in the list',
      fileTooLarge: 'The file «{{name}}» exceeds 50 MB',
      fileNotZip: 'The file «{name}» is not a .zip archive',
      fileNotSupported: 'The file «{{name}}» is not supported',
      importError: 'Import error: {{message}}',
      importErrorDefault: 'Import failed. Please try again.',

      modalTitle: 'Enter password to import',
      inputPlaceholder: 'Password',
      confirm: 'OK',
      decline: 'Cancel',
      passwordError: 'Incorrect password. Please try again.',

      button: 'Import',
      state: 'Importing…',

      pending: 'Pending import',
      unitState: 'File imported',
    },
  };

export default value;
